import { render, staticRenderFns } from "./sun.vue?vue&type=template&id=505245a1"
import script from "./sun.vue?vue&type=script&lang=js"
export * from "./sun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports